export default __webpack_public_path__ + "static/media/element_49.eb65bd18.jpg";